import MostGenericErrorBoundary from './MostGenericErrorBoundary';

export default MostGenericErrorBoundary;